<template>
  <div class="input__wrapper">
    <div class="input__label" :class="{'input__label--disabled': disabled}">{{ label }}</div>
    <input
      class="input"
      v-model="val"
      :type="type"
      :placeholder="placeholder"
      :maxlength="maxlength"
      :max="max"
      :autocomplete="isAutofill()"
      @input="input"
      @keyup="keyupHandler"
      @click="$emit('click', $event)"
      @blur="$emit('blur', $event)"
      :class="[invalid ? 'input__invalid' : '']"
      :disabled="disabled"
    >
  </div>
</template>

<script>
export default {
  data () {
    return {
      val: ''
    }
  },
  props: {
    value: {},
    label: String,
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: String,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    invalid: Boolean,
    passwordAutofillDisabled: Boolean,
    disabled: Boolean,
    onEnter: Function
  },
  watch: {
    value: function () {
      if (this.value !== null) this.val = this.value
      else this.val = null
    }
  },
  mounted () {
    if (this.value !== null) this.val = this.value
    else this.val = null
  },
  methods: {
    input () {
      if (!this.val.length) this.$emit('input', null)
      this.$emit('input', this.val)
    },

    isAutofill () {
      if (this.type !== 'password') return ''
      else {
        if (this.passwordAutofillDisabled) return 'new-password'
        return 'current-password'
      }
    },

    keyupHandler(e){
      if(e.code === 'Enter') this.$emit('enter', e)
      this.$emit('keyup', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.input {
  @include inputStyle(5px);

  &:focus {
    outline: none;
    border-color: $borderAccent;
  }

  &__label {
    @include labelStyle();

    &--disabled {
      color: $inactiveGrey;
    }
  }

  &__invalid {
    background-color: $invalidInput;
  }
}
</style>
